<template>
  <div class="recharge_wrap invest-page">
    <div class="red_top_bg page-top">
      <div
        class="back_left"
        @click="$router.go(-1)"
      />
      <div class="big_tit">
        {{ $t('invest.recharge') }}
      </div>
      <button
        type="button"
        class="top_right"
        @click="$router.push('/rechargeRecord')"
      >
        <van-icon
          name="bars"
          size="22"
        />
      </button>
    </div>

    <section
      v-if="eye == 1"
      class="balance-card"
    >
      <p>{{ $t('sky.jifen') }}</p>
      <strong>{{ balance }}</strong>
      <span>{{ $t('invest.availableBalance') }}</span>
    </section>
    <section
      v-if="eye == 0"
      class="balance-card"
    >
      <strong>******</strong>
      <span>
        {{ $t('invest.availableBalance') }}
        <van-icon
          name="closed-eye"
          @click="eye = 1"
        />
      </span>
    </section>

    <form class="form">
      <section class="amount-card">
        <p class="card-title">
          {{ $t('invest.rechargeAmount') }}
        </p>
        <div class="amount-field">
          <input
            v-model.trim="data.money"
            type="number"
            min="1"
            step="1"
            class="inp"
            :placeholder="$t('invest.rechargeAmount')"
            @input="changeAmount"
          >
          <span class="amount-mark">{{ payment.mark }}</span>
        </div>
        <p
          v-if="actualAmount"
          class="amount-preview"
        >
          {{ actualAmount }}
        </p>
      </section>

      <section class="payment-card">
        <div class="tit">
          {{ $t('invest.paymentMethod') }}
        </div>
        <div
          v-for="(v, k) in paymentList"
          :key="v.id || k"
          class="item"
          :class="{ active: k + 1 == data.choose }"
          @click="choose_type(k + 1, v)"
        >
          <div
            class="check"
            :class="k + 1 == data.choose ? 'checked' : ''"
          />
          <div class="re_icon">
            <img
              :src="v.logo"
              alt=""
            >
          </div>
          <div class="re_name">
            {{ v.name }}
          </div>
        </div>
      </section>

      <button
        type="button"
        class="basic_btn sbtn"
        @click="submit"
      >
        {{ $t('invest.next') }}
      </button>
    </form>

    <div
      v-if="data.channel != 5"
      class="tip"
    >
      {{ $t('invest.tip') }}
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import {
  CountDown,
  Checkbox,
  RadioGroup,
  Icon,
  Radio
} from 'vant';
import Fetch from '../../utils/fetch';

Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(CountDown).use(Checkbox).use(Icon);

export default {
  name: "Invest",
  data() {
    return {
      time: 0,
      eye: 1,
      balance: 0,
      data: {
        choose: '',
        channel: '',
        money: '',
        id: '',
        reason: ''
      },
      payment: [],
      config: {},
      actualAmount: '',
    };
  },
  computed: {
    paymentList() {
      return this.config && this.config.payment ? this.config.payment : [];
    }
  },
  created() {
    this.$parent.footer('user', false);
  },
  mounted() {
    this.start();
    var num = this.$router.history.current.params.code;
    if (num && num > 0) {
      this.data.money = num;
    }
  },
  methods: {
    start() {
      Fetch('/user/recharge', {
        ...this.data
      }).then((r) => {
        this.balance = (1*r.data.money).toFixed(2);
        this.config = r.data;
        this.config.min_recharge = parseInt(this.config.min_recharge);
        if (r.data.payment && r.data.payment[0]) {
          this.choose_type(1, r.data.payment[0]);
        }
      });
    },
    checkLimit() {
      const key = 'invest_button';
      const ttl = 60;
      let now = Date.parse(new Date()) / 1000;
      let val = localStorage.getItem(key);
      if (!val) {
        val = JSON.stringify({
          'ttl': now + ttl
        });
        localStorage.setItem(key, val);
        return true;
      } else {
        val = JSON.parse(val);
        if (val['ttl'] > now) {
          return false;
        } else {
          val = JSON.stringify({
            'ttl': now + ttl
          });
          localStorage.setItem(key, val);
          return true;
        }
      }
    },
    choose_type(k, payment) {
      this.data.choose = k;
      this.data.channel = payment.type;
      this.data.id = payment.id;
      this.payment = payment;
      this.changeAmount();
    },
    getRechargeAmount() {
      var amount = Number(this.data.money);
      if (!isFinite(amount) || amount <= 0) {
        return 0;
      }
      if (this.payment.type == 1) {
        var rate = Number(this.payment.rate);
        if (!isFinite(rate) || rate <= 0) {
          return 0;
        }
        var convertedAmount = amount * rate;
        return isFinite(convertedAmount) ? convertedAmount : 0;
      }
      return amount;
    },
    submit() {
      var rechargeAmount = this.getRechargeAmount();
      if (!this.data.money || rechargeAmount < this.config.min_recharge) {
        this.$toast(this.$t('invest.rechargeAmountLow') + " " + this.utils_moneyMark() + this.config
          .min_recharge + this.$t('invest.rechargeAmountLow1'));
        return false;
      }
      if (!this.data.channel) {
        this.$toast(this.$t('invest.paymentMethodEmpty'));
        return false;
      }
		this.$router.push("/kefu");
      if (this.data.channel == 4) {
        // this.$router.replace({
        //   path: '/invest/bank',
        //   query: {
        //     money: this.data.money,
        //     id: this.data.id
        //   }
        // });
        return;
      } else if (this.data.channel == 1) {
        // this.$router.replace({
        //   path: '/invest/usdt',
        //   query: {
        //     money: this.data.money,
        //     id: this.data.id,
        //     type: 2,
        //     reason: this.data.reason
        //   }
        // });
        return;
      } else {
        Fetch('/user/recharge_type', {
          money: this.data.money,
          id: this.data.id
        }).then((r) => {
          this.$router.push("/kefu");
          if (r.data.payment.payurl != '') {
            // Reserved for existing third-party payment redirect behavior.
          }
        });
      }
    },
    changeAmount() {
      var num = 0;
      var rate = Number(this.payment.rate);
      if (!this.payment.type || !this.data.money || !isFinite(rate) || rate <= 0) {
        this.actualAmount = '';
        return;
      }
      if (this.payment.type == 1) {
        this.actualAmount = this.utils_moneyMark() + ' ' + this.getRechargeAmount().toFixed(2);
      } else {
        this.actualAmount = this.payment.mark + ' ' + (this.data.money / rate).toFixed(num);
      }
    }
  }
};
</script>

<style lang="less" scoped>
.invest-page {
  min-height: 100vh;
  padding-bottom: 96px;
  background: #fff;
  color: #16223a;
  box-sizing: border-box;
}

button {
  border: 0;
  font: inherit;
  cursor: pointer;
}

.page-top {
  background: #fff;
  color: #16223a;
  border-bottom: 1px solid rgba(240, 242, 245, 1);
  box-sizing: border-box;

  .back_left {
    opacity: 0.88;
  }

  .big_tit {
    max-width: 72%;
    color: #16223a;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    word-break: normal;
  }
}

.top_right {
  top: 9px;
  right: 15px;
  width: 32px;
  height: 32px;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: #ff5d7a;
  background: rgba(255, 93, 122, 0.12);
}

.balance-card,
.amount-card,
.payment-card,
.tip {
  margin: 14px 16px 0;
  overflow: hidden;
  border-radius: 14px;
  border: 1px solid rgba(255, 93, 122, 0.16);
  background: #fff;
  box-shadow: 0 12px 22px rgba(22, 34, 58, 0.08);
  box-sizing: border-box;
}

.balance-card {
  padding: 20px 18px;
  text-align: center;
  background: #fff6f8;
}

.balance-card p,
.balance-card span {
  margin: 0;
  color: #6d7688;
  font-size: 14px;
  line-height: 20px;
}

.balance-card strong {
  display: block;
  margin: 10px 0 8px;
  overflow: hidden;
  color: #ff5d7a;
  font-size: 24px;
  font-weight: 700;
  line-height: 30px;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: normal;
}

.form {
  margin: 0;
}

.amount-card {
  padding: 16px;
}

.card-title,
.tit {
  margin: 0;
  color: #16223a;
  font-size: 16px;
  font-weight: 700;
  line-height: 22px;
}

.amount-field {
  min-height: 48px;
  margin-top: 14px;
  padding: 0 12px;
  display: flex;
  align-items: center;
  border-radius: 10px;
  background: #fff6f8;
  box-sizing: border-box;
}

.amount-field input {
  min-width: 0;
  height: 48px;
  flex: 1;
  border: 0;
  outline: none;
  background: transparent;
  color: #16223a;
  font-size: 16px;
  line-height: 48px;
}

.amount-field input::placeholder {
  color: #6d7688;
}

.amount-field:focus-within {
  border-color: rgba(255, 93, 122, 0.52);
  box-shadow: 0 0 0 3px rgba(255, 93, 122, 0.1);
}

.amount-field input {
  caret-color: #ff5d7a;
}

.amount-field input:-webkit-autofill,
.amount-field input:-webkit-autofill:hover,
.amount-field input:-webkit-autofill:focus {
  -webkit-text-fill-color: #16223a;
  box-shadow: 0 0 0 1000px #fff6f8 inset;
  caret-color: #ff5d7a;
}

.amount-mark {
  flex: 0 0 auto;
  margin-left: 10px;
  color: #ff5d7a;
  font-size: 14px;
  font-weight: 700;
}

.amount-preview {
  margin: 12px 0 0;
  overflow: hidden;
  color: #6d7688;
  font-size: 12px;
  line-height: 18px;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: normal;
}

.payment-card {
  padding: 0 16px;
}

.tit {
  height: 54px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid rgba(240, 242, 245, 1);
}

.item {
  min-height: 58px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid rgba(240, 242, 245, 1);
}

.item:last-child {
  border-bottom: 0;
}

.item.active .re_name {
  color: #ff5d7a;
}

.check {
  width: 16px;
  height: 16px;
  flex: 0 0 16px;
  margin-left: 2px;
  border-radius: 50%;
  border: 1px solid rgba(255, 93, 122, 0.42);
  background: #fff0f4;
  box-sizing: border-box;
}

.check.checked {
  border: 4px solid #ff5d7a;
  background: #ff5574;
}

.re_icon {
  width: 36px;
  height: 36px;
  flex: 0 0 36px;
  margin-left: 12px;
  overflow: hidden;
  border-radius: 8px;
  background: #fff6f8;
}

.re_icon img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: contain;
}

.re_name {
  min-width: 0;
  margin-left: 10px;
  overflow: hidden;
  color: #16223a;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: normal;
}

.basic_btn {
  width: calc(100% - 32px);
  height: 44px;
  margin: 24px 16px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  border: 1px solid rgba(255, 93, 122, 0.42);
  background: linear-gradient(180deg, #ff7791 0%, #ff5574 100%);
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  box-sizing: border-box;
}

.tip {
  padding: 14px 16px;
  color: #6d7688;
  font-size: 12px;
  line-height: 20px;
}

@media screen and (max-width: 374px) {
  .balance-card,
  .amount-card,
  .payment-card,
  .tip {
    margin-right: 12px;
    margin-left: 12px;
  }

  .basic_btn {
    width: calc(100% - 24px);
    margin-right: 12px;
    margin-left: 12px;
  }
}
</style>
